import * as React from 'react';
import { Wrapper } from './styles';

export const Footer = (): JSX.Element => (
  <Wrapper>
    Exams Office Tech Support <i className="fas fa-copyright"></i> {new Date().getFullYear()}
  </Wrapper>
);
